import { EmployeeQcqQualityItem } from '@/types/service-response'

export class EmployeeQcqQuality {
  private constructor (
    readonly id: number | null,
    readonly numbersOfStars: number | null,
    readonly employeeId: number | null
  ) {}

  public static createFromResponse (data: EmployeeQcqQualityItem): EmployeeQcqQuality {
    let result: EmployeeQcqQuality = new EmployeeQcqQuality(
      data ? data.ID : null,
      data ? data.NumbersOfStars : null,
      data ? data.MitarbeiterID : null
    )
    return result
  }
}